import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';

// Información de pago por transferencia bancaria
const BANK_INFO = {
  clabe: '722969010029200517',
  beneficiary: 'Fernando Avila',
  whatsapp: 'https://wa.me/2296847814'
};

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading } = useAuth();
  const paymentId = searchParams.get('payment_id');

  useEffect(() => {
    // Redirigir al dashboard después de 5 segundos si el usuario tiene licencia
    const timer = setTimeout(() => {
      if (user) {
        navigate('/dashboard');
      } else {
        navigate('/login');
      }
    }, 5000);

    return () => clearTimeout(timer);
  }, [user, navigate]);

  if (loading) {
    return (
      <LoadingSpinner
        label="Cargando…"
        height="100vh"
        style={{ background: 'var(--bg-primary)', color: 'var(--text-primary)' }}
      />
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, var(--navy-deep, #0a1a2a) 0%, var(--navy-light, #162a3d) 100%)',
      color: 'white',
      fontFamily: "'Segoe UI', Roboto, sans-serif",
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        padding: '3rem',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)'
      }}>
        <div style={{
          background: 'rgba(16, 185, 129, 0.1)',
          border: '1px solid rgba(16, 185, 129, 0.3)',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '1.5rem'
        }}>
          <div style={{
            fontSize: '3rem',
            marginBottom: '1rem',
            textAlign: 'center'
          }}>
            ✅
          </div>
          <h2 style={{
            margin: '0 0 0.5rem 0',
            color: '#10b981',
            fontSize: '1.5rem',
            textAlign: 'center'
          }}>
            ¡Transferencia Recibida!
          </h2>
          <p style={{
            color: '#cbd5e1',
            fontSize: '0.95rem',
            textAlign: 'center',
            margin: '0 0 1rem 0'
          }}>
            Hemos recibido la notificación de tu transferencia bancaria.
          </p>
          <div style={{
            background: 'rgba(0, 0, 0, 0.2)',
            padding: '0.75rem',
            borderRadius: '8px',
            marginBottom: '1rem'
          }}>
            <p style={{
              margin: 0,
              color: '#94a3b8',
              fontSize: '0.85rem',
              textAlign: 'center',
              lineHeight: '1.6'
            }}>
              Tu licencia será activada en <strong style={{ color: '#10b981' }}>24-48 horas hábiles</strong> después de verificar tu comprobante de pago.
            </p>
          </div>
        </div>

        {/* Instrucciones de Activación Manual */}
        <div style={{
          background: 'linear-gradient(135deg, rgba(251, 191, 36, 0.1) 0%, rgba(245, 158, 11, 0.1) 100%)',
          border: '2px solid rgba(251, 191, 36, 0.3)',
          borderRadius: '12px',
          padding: '1.5rem',
          marginBottom: '1.5rem'
        }}>
          <h5 style={{
            margin: '0 0 1rem 0',
            color: '#fbbf24',
            fontSize: '1.1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            📋 <span>Siguiente Paso: Envía tu Comprobante</span>
          </h5>
          <p style={{
            color: '#e5e7eb',
            fontSize: '0.9rem',
            margin: '0 0 1rem 0',
            lineHeight: '1.6'
          }}>
            Para completar la activación de tu licencia, envía tu comprobante de pago por WhatsApp:
          </p>

          {/* Datos de transferencia */}
          <div style={{
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1rem'
          }}>
            <p style={{
              color: '#cbd5e1',
              fontSize: '0.85rem',
              margin: '0 0 0.75rem 0',
              fontWeight: '600'
            }}>
              Datos de la transferencia:
            </p>
            <div style={{ marginBottom: '0.5rem' }}>
              <p style={{ margin: '0 0 0.25rem 0', color: '#94a3b8', fontSize: '0.75rem' }}>CLABE:</p>
              <p style={{ margin: 0, color: '#fff', fontSize: '0.9rem', fontFamily: 'monospace', fontWeight: '600' }}>
                {BANK_INFO.clabe}
              </p>
            </div>
            <div>
              <p style={{ margin: '0 0 0.25rem 0', color: '#94a3b8', fontSize: '0.75rem' }}>Beneficiario:</p>
              <p style={{ margin: 0, color: '#fff', fontSize: '0.9rem', fontWeight: '600' }}>
                {BANK_INFO.beneficiary}
              </p>
            </div>
          </div>

          <div style={{
            background: 'rgba(0, 0, 0, 0.2)',
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '1.5rem'
          }}>
            <p style={{
              color: '#cbd5e1',
              fontSize: '0.85rem',
              margin: '0 0 0.5rem 0',
              fontWeight: '600'
            }}>
              Incluye en tu mensaje de WhatsApp:
            </p>
            <ul style={{
              margin: 0,
              paddingLeft: '1.5rem',
              color: '#94a3b8',
              fontSize: '0.85rem',
              lineHeight: '1.8'
            }}>
              <li>Tu <strong>comprobante de pago</strong> (captura o foto)</li>
              <li>El <strong>correo electrónico</strong> para activar tu licencia</li>
            </ul>
          </div>

          {/* Botón de WhatsApp */}
          <a
            href={BANK_INFO.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.75rem',
              width: '100%',
              background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
              border: 'none',
              padding: '14px 28px',
              color: 'white',
              borderRadius: '50px',
              fontSize: '1.05rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
              textDecoration: 'none'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.6)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(37, 211, 102, 0.4)';
            }}
          >
            <span style={{ fontSize: '1.5rem' }}>💬</span>
            <span>Enviar Comprobante por WhatsApp</span>
          </a>

          <p style={{
            color: '#94a3b8',
            fontSize: '0.8rem',
            margin: '1rem 0 0 0',
            textAlign: 'center',
            fontStyle: 'italic'
          }}>
            ⏱️ Tiempo de activación: 24-48 horas hábiles
          </p>
        </div>
        <div style={{
          background: 'rgba(16, 185, 129, 0.1)',
          border: '1px solid rgba(16, 185, 129, 0.3)',
          borderRadius: '12px',
          padding: '1rem',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: 0, color: '#10b981', fontSize: '0.9rem' }}>
            ⏳ Serás redirigido automáticamente al dashboard en unos segundos...
          </p>
        </div>
        <button
          onClick={() => user ? navigate('/dashboard') : navigate('/login')}
          style={{
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            border: 'none',
            padding: '12px 32px',
            color: 'white',
            borderRadius: '50px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'transform 0.2s, box-shadow 0.2s',
            boxShadow: '0 4px 15px rgba(16, 185, 129, 0.4)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 20px rgba(16, 185, 129, 0.6)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 15px rgba(16, 185, 129, 0.4)';
          }}
        >
          {user ? 'Ir al Dashboard' : 'Iniciar Sesión'}
        </button>
      </div>
      <div style={{ marginTop: '2rem', color: '#64748b', fontSize: '0.8rem' }}>
        Vortex EXANI-II © {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default PaymentSuccess;
